// extracted by mini-css-extract-plugin
export default {"container":"ModalMoveInfo_container__9RLs5","textConfirmation":"ModalMoveInfo_textConfirmation__vQlND","moveData":"ModalMoveInfo_moveData__EB8dm","row":"ModalMoveInfo_row__6px+y"};